import { useCallback } from 'react';
import { gql } from 'apollo-boost';
import { useMutation } from 'shared/apollo';

export const updateService = gql`
  mutation updateService(
    $id: Int!,
    $name: String!,
    $description: String!,
    $collectionIds: String!,
    $indicatorIds: String!,
  ) {
  updateService(
    id: $id,
    name: $name,
    description: $description,
    collectionIds: $collectionIds,
    indicatorIds: $indicatorIds,
  ) {
      success
      id
    }
  }
`;

export function useUpdateService() {
  const { data, isLoading, mutate } = useMutation();
  const run = useCallback((variables, onFinish) => {
    mutate(updateService, variables, response => {
      if (typeof onFinish === 'function') {
        onFinish(response.updateService.id);
      }
    });
  }, []);
  return { data, isLoading, run };
}
